import { BannerUltraSlim as BannerUltraSlimTemplate } from '@/organisms';

import type { TypeBannerUltraSlimProps } from '@/organisms/banner-ultraslim';

interface TypeBannerUltra {
  id: string;
  bloque: {
    fieldGroupName: string;
  } & TypeBannerUltraSlimProps;
}

const BannerUltraSlim = ({ id, bloque }: TypeBannerUltra) => (
  <section id={id} className="relative mx-auto py-4">
    <BannerUltraSlimTemplate {...bloque} />
  </section>
);

BannerUltraSlim.displayName = 'BannerUltraSlim';
export default BannerUltraSlim;
